document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.getElementById("mobile-menu-toggle");
  const menu = document.getElementById("mobile-menu");

  if (!toggle || !menu) return;

  toggle.addEventListener("click", function () {
    menu.classList.toggle("hidden");
  });
});

(function () {
  const toc = document.getElementById("boat-toc");
  const firstSection =
    document.getElementById("description") ||
    document.getElementById("details");
  const links = Array.from(document.querySelectorAll(".boat-toc-link"));
  const headerOffset = 130;
  const sectionTopPadding = window.matchMedia("(min-width: 768px)").matches
    ? 96
    : 80;

  if (!toc || !firstSection || !links.length) return;

  const sections = links
    .map(function (link) {
      return document.querySelector(link.getAttribute("href"));
    })
    .filter(Boolean);

  function setActive(id) {
    links.forEach(function (link) {
      link.classList.toggle(
        "is-active",
        link.getAttribute("href") === "#" + id,
      );
    });
  }

  function updateTocPosition() {
    const rect = firstSection.getBoundingClientRect();
    const top = Math.max(headerOffset, rect.top + sectionTopPadding);

    toc.style.top = top + "px";
    toc.classList.toggle("opacity-0", rect.top > window.innerHeight - 120);
    toc.classList.toggle(
      "pointer-events-none",
      rect.top > window.innerHeight - 120,
    );
  }

  function updateActiveSection() {
    let activeId = sections[0].id;
    const marker = headerOffset + sectionTopPadding + 8;

    sections.forEach(function (section) {
      if (section.getBoundingClientRect().top <= marker) {
        activeId = section.id;
      }
    });

    setActive(activeId);
  }

  links.forEach(function (link) {
    link.addEventListener("click", function (event) {
      const target = document.querySelector(link.getAttribute("href"));
      if (!target) return;

      event.preventDefault();
      setActive(target.id);

      const targetTop =
        target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: targetTop, behavior: "smooth" });
    });
  });

  function updateToc() {
    updateTocPosition();
    updateActiveSection();
  }

  window.addEventListener("scroll", updateToc, { passive: true });
  window.addEventListener("resize", updateToc);
  updateToc();
})();

jQuery(function ($) {
  function initGallerySlider(config) {
    const $slider = $(config.slider);
    const $bar = $(config.progressBar);

    if (!$slider.length || typeof $slider.slick !== "function") {
      return;
    }

    if ($slider.hasClass("slick-initialized")) {
      return;
    }

    $slider.on(
      "init reInit afterChange",
      function (event, slick, currentSlide) {
        const index = (currentSlide || 0) + 1;
        const percent = (index / slick.slideCount) * 100;
        $bar.css("width", percent + "%");
      },
    );

    $slider.slick({
      slidesToShow: config.slidesToShow || 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $(config.prevArrow),
      nextArrow: $(config.nextArrow),
      dots: false,
      //infinite: false,
      responsive: config.responsive || [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 520, settings: { slidesToShow: 1 } },
      ],
    });
  }

  initGallerySlider({
    slider: ".boat-gallery-slider",
    progressBar: ".boat-gallery-progress-bar",
    prevArrow: ".boat-gallery-prev",
    nextArrow: ".boat-gallery-next",
    slidesToShow: 5,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 520, settings: { slidesToShow: 1 } },
    ],
  });

  initGallerySlider({
    slider: ".about-gallery-slider",
    progressBar: ".about-gallery-progress-bar",
    prevArrow: ".about-gallery-prev",
    nextArrow: ".about-gallery-next",
    slidesToShow: 5,
    infinite: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1.2 } },
      { breakpoint: 520, settings: { slidesToShow: 1 } },
    ],
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (typeof lightbox !== "undefined") {
    lightbox.option({
      albumLabel: "Image %1 of %2",
      fadeDuration: 300,
      resizeDuration: 300,
      wrapAround: true,
    });
  }
});
